import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, makeStyles, Button } from '@material-ui/core';
import CardEmpresa from '../presentations/CardEmpresa';
import SelecaoEmpresaService from '../services/SelecaoEmpresaService';
import { MenuEnum } from '../enums';
import { Loading } from '../presentations';
import { resetarStateFaturamento } from '../redux/actions/FaturamentoAction';
import { resetarStatePedido } from '../redux/actions/PedidoAction';

const useStyles = makeStyles(theme => ({
    btn_ok: {
        color: theme.palette.primary.contrastText
    }
}));

function ListagemCardEmpresa(
    {
        history,
        handleError,

        resetarStateFaturamento,
        resetarStatePedido
    }
) {
    const classes = useStyles();
    const [listaEmpresa, setListaEmpresa] = useState([]);
    const [loading, setLoading] = useState(null);
    const [selecao, setSelecao] = useState(null);
    const [cusNum, setCusNum] = useState(null);

    useEffect(() => {
        setLoading(true);
        SelecaoEmpresaService.obterListagemEmpresaCard()
            .then((response) => {
                setLoading(false);
                setListaEmpresa(response.data);
            }).catch((error) => {
                setLoading(false);
                handleError(error);
            });
    }, [handleError]);

    const handleSelecionarCard = (index, value) => {
        const ud = JSON.parse(localStorage.getItem('user_data'));
        ud.codigoEmpresa = value.codigoEmpresa;
        ud.razaoSocial = value.razaoSocial;

        setCusNum(value.codigoEmpresa);
        setSelecao(index);

        localStorage.setItem('user_data', JSON.stringify(ud));
    }

    const handleOk = () => {
        resetarStateFaturamento();
        resetarStatePedido();
        history.push(MenuEnum.properties[MenuEnum.HOME].path);
    }

    if (loading === null ||
        loading === true)
        return <Loading />

    return (
        <Grid container
            direction="column"
            alignItems="center"
            justify="center">
            <Grid item xs={11}>
                {
                    listaEmpresa.map((item, index) =>
                        <CardEmpresa key={index}
                            index={index}
                            selecao={selecao}
                            empresa={item}
                            handleSelecionarCard={handleSelecionarCard} />)
                }
            </Grid>
            <Grid item>
                <Button variant="contained"
                    color="primary"
                    className={classes.btn_ok}
                    disabled={cusNum === null}
                    onClick={handleOk}>
                    OK
                </Button>
            </Grid>
        </Grid>
    );
}

const mapDispatchToProps = {
    resetarStateFaturamento,
    resetarStatePedido
};

export default connect(null, mapDispatchToProps)(withRouter(ListagemCardEmpresa));